import { MijnRoute } from '../mijn-navigatie.model';

export const AFLOSVRIJ_CHECK: MijnRoute = {
    path: 'aflosvrij-check',
    navigationEvent: 'toAflosvrijCheck',
    regex: /^\/aflosvrij-check$/,
    webcomponent: 'mijn-aflosvrij-check-webcomponent'
};
